import moment from 'moment-timezone'
import _ from 'lodash'
// Displays datetime with the given format.
export const displayDatetime = (
	str,
	format = 'DD MMM YYYY [at] HH:mm',
	timezone
) => {
	if (timezone) {
		return moment(str).tz(timezone).format(format)
	}
	return moment(str).format(format)
}

// Extracts browser name and version from user agent string.
export const getBrowser = () => {
	const { userAgent: ua } = navigator
	const browsers = [
		'Puffin',
		'YaBrowser',
		'MiuiBrowser',
		'UCBrowser',
		'IEMobile',
		'MSIE',
		'Trident',
		'OPR',
		'OPiOS',
		'Opera',
		'SamsungBrowser',
		'Edg',
		'Edge',
		'FxiOS',
		'Firefox',
		'CriOS',
		'Chrome',
		'Safari'
	]
	let retval = ua
	for (const browser of browsers) {
		const matches = ua.match(new RegExp(`^.*(${browser}/[\\.\\d]+).*$`))
		const result = matches && matches.length > 1 ? matches[1] : ''
		if (result) {
			retval = result
			break
		}
	}
	return retval
}

// Gets device meta data: browser, os (and app info: name, ver, env).
export const getDeviceMetaData = () => {
	// Get OS:
	const { userAgent } = navigator
	const matches = userAgent.match(/.*?\((.+?)\).*/)
	const os = matches && matches.length > 1 ? matches[1] : userAgent

	const { VUE_APP_NAME, VUE_APP_VERSION, VUE_APP_ENV } = process.env
	return {
		app: VUE_APP_NAME,
		ver: VUE_APP_VERSION,
		env: VUE_APP_ENV,
		browser: getBrowser(),
		os
	}
}

export const noop = () => {}

// Just for test.
export const delay = (time = 1000) => {
	return new Promise(resolve => {
		setTimeout(resolve, time)
	})
}

export const getValueByPath = (obj, path, defaultVal) => {
	return (
		path.split('.').reduce((acc, part) => acc && acc[part], obj) ||
		defaultVal
	)
}

export const getTimezone = (locations, locationId) => {
	return _.chain(locations)
		.find({ id: locationId })
		.get('timezone', 'Asia/Hong_Kong')
		.value()
}
